import { Component, inject, OnInit } from "@angular/core"
import { Router } from "@angular/router"
import { BaseCustomComponent } from "src/app/modules/common"

import { AuthService } from "~services/auth.service"

@Component({
  selector: "app-auth-page",
  templateUrl: "./auth-page.component.html",
  styleUrls: ["./auth-page.component.scss"],
  standalone: false
})
export class AuthPageComponent extends BaseCustomComponent implements OnInit {
  router = inject(Router)
  authService = inject(AuthService)

  ngOnInit() {
    this.cleanSubscribe(this.authService.user$, async (user) => {
      if (user) {
        await this.successCallback()
      }
    })
  }

  successCallback() {
    return this.router.navigate(["/"])
  }

  login() {
    return this.authService.login()
  }
}
